import React, { useState, useEffect } from 'react';
import Item from '../Statistics/Item';
import axios from '../../../util/Api';

const RequestCount = () => {
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState(null);

  useEffect(() => {
    setLoading(true);
    const url = `/passport/request-count`;
    axios.get(url, { params: {status: 10} }).then(resp => {
      setRequest(resp.data);
      setLoading(false);
    }).catch(err=>{});
  }, []);
  return (
    <Item label={`Request Pekerja`} value={request} loading={loading} />
  );
}

export default RequestCount;